var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"table-container"},[_c('vue-good-table',{attrs:{"styleClass":"vgt-table table table-stat","columns":_vm.columns,"rows":_vm.rows,"sort-options":{
          enabled: true,
          initialSortBy: {field: 'id', type: 'desc'}
        },"pagination-options":{
          enabled: true,
          perPage: 25,
          perPageDropdown: [10, 25, 50, 100],
          dropdownAllowAll: false,
          jumpFirstOrLast : true,
          rowsPerPageLabel: 'Строк на странице',
          allLabel: 'Все',
          ofLabel: 'из',
          prevLabel: 'Назад',
          nextLabel: 'Вперед',
          firstLabel : 'В начало',
          lastLabel : 'В конец',
        },"compactMode":""},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'feedId')?_c('span',[(props.row.feedId > 0)?_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'FeedId', params: { id: props.row.feedId }}}},[_vm._v(_vm._s(props.row.feedName))]):_c('span',[_vm._v("-")])],1):(props.column.field === 'changes')?[_c('ChangesList',{attrs:{"changes":props.row.changes}})]:_c('span',{domProps:{"innerHTML":_vm._s(props.formattedRow[props.column.field])}})]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }